export const GPOVALLAS_FOLDER_NAMES = {
  'auto-resolution': 'Auto Resolution',
  'auto-resolution-branded': 'Auto Resolution Branded'
} as const;
